// frontend/src/context/UserContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";
import { env } from "../constants/env";
import { toast } from "react-toastify";

// Create Context
const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("userToken"));
  const [loading, setLoading] = useState(true);

  // Fetch user data
  useEffect(() => {
    fetchUserData();
  }, [token]);

  const fetchUserData = async () => {
    console.log("ARW WE REACHING HERE");
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`${env.apiUrl}/api/user`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(response.data);
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status === 401 || status === 403) {
          toast.error("Session expired. Please log in again.");
          logout(); // auto-logout for invalid/expired token
        } else {
          toast.error(`Error fetching user: ${status}`);
        }
      } else {
        toast.error("Network error. Please check your internet connection.");
      }
      console.error("User fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    // Clear auth data
    setToken(null);
    setUser(null);
    localStorage.removeItem("userToken");

    // Optional: Clear other app-related localStorage/sessionStorage if needed
    localStorage.clear();
    sessionStorage.clear();

    // Optional: Show a confirmation or toast (if your app uses notifications)
    toast.success("You have been logged out");

    // Redirect to homepage or login
    window.location.replace(env.siteUrl); // Better than href to prevent back navigation
  };

  return (
    <UserContext.Provider
      value={{ user, setUser, loading, logout, fetchUserData }}
    >
      {children}
    </UserContext.Provider>
  );
};
